<template src="./template.html" />

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import fractionsApi from '@/api/companies/fractions'
import vehiclesApi from '@/api/vehicles'

export default {
  name: 'new_vehicle_chamber',
  inject: ['companyUser'],
  data: () => ({
    vehicle: {},
    chamber: {},
    fractions: [],
    templateMode: 'add',
  }),
  components: { BreadCrumbs, CompanyNav, SectionHeader },
  methods: {
    submitVehicleChamber: async function () {
      const result = await vehiclesApi.chambers.create(this.$route.params.vehicle_uuid, this.chamber)
      if (result.success) {
        await this.$router.push(`/company/vehicles/${this.$route.params.vehicle_uuid}`)
      }
    },
  },
  async mounted() {
    this.vehicle = await vehiclesApi.get(this.$route.params.vehicle_uuid)
    this.fractions = await fractionsApi.getAll(this.companyUser.company.uuid)
  },
}
</script>
